import { Provider } from '@vgtv/api-client';

import { getAssetAccessLevel } from '../../shared/helpers/assetHelpers';
import { getUtmParams } from '../../services/tracking/helpers/utmParams';
import { isHermesApp, isIOS, isSportApp } from '../../utils/device';
import { config } from '../../config';
import { getPurchaseUrl } from '../Paywall/PaywallPopup/helpers/getPurchaseUrl';
import { getCategoryShortPath } from '../../shared/helpers/categoryHelpers';
import { getCurrentPageViewData } from '../../services/tracking/helpers/pulseOrigin';

import type { ProviderAccessMap } from '@vgtv/svp-access/lib/access_mappings';
import type { SvpAssetAdditional } from '@vgtv/api-client/lib/svp_asset';

function getVGSubscriptionUrl(
  asset: SvpAssetAdditional,
  overrides: {
    access?: ProviderAccessMap[Provider];
    code?: string;
  } = {}
) {
  const access = overrides.access || getAssetAccessLevel(asset);
  const assetId = asset.id;

  if (isHermesApp && isIOS) {
    return `https://www.vg.no/i/${isSportApp ? '25PMrr' : 'eMWAwO'}`;
  }

  return getPurchaseUrl(String(assetId), {
    code: overrides.code || (access === 'sport' ? 'VGS-1M129-E' : 'VGB-1W49-E'),
    content_id: 'fallback',
  });
}

function getABSubscriptionUrl(
  asset: SvpAssetAdditional,
  overrides: {
    access?: ProviderAccessMap[Provider];
    code?: string;
  } = {}
) {
  const assetId = asset.id;

  if (isHermesApp && isIOS) {
    return 'https://www.aftonbladet.se/a/rqpaA';
  }

  const subscriptionUrl =
    'https://payment.schibsted.com/authn/payment/purchase/code';

  const source = '';
  const category = getCategoryShortPath(asset.category);
  const utmParams = getUtmParams();

  const x_domain_id = getCurrentPageViewData().xDomainId;

  const query = {
    refpartner: source,
    client_id: '4f1692bb9daf7cd367000001',
    publisher: 'ab',
    type: 'MediaAsset',
    utm_source: utmParams.utm_source || 'editorial',
    utm_channel: utmParams.utm_channel || `abtv-${category}`,
    utm_campaign: utmParams.utm_campaign || 'abplus_video',
    utm_content: utmParams.utm_content || 'inline_video_teaser',
    redirect_uri: 'https://www.aftonbladet.se/callback',
    // utm_term: 'aftonbladettv,olof-rohlander',
    // custom parameter to track url of purchase click
    utm_url: window.location.href.split('?')[0],
    content_id: assetId,
    code: overrides.code!,
    state: JSON.stringify({ returnPath: window.location.href }),
    ...(x_domain_id && { x_domain_id }),
  };

  const queryString = Object.entries(query)
    .map(([key, val]) => {
      return [key, encodeURIComponent(val)].join('=');
    })
    .join('&');

  return `${subscriptionUrl}?${queryString}`;
}

export function getSubscriptionUrl(
  asset: SvpAssetAdditional,
  overrides: {
    access?: ProviderAccessMap[Provider];
    code?: string;
  } = {}
) {
  const { provider } = config;

  if (provider === Provider.VGTV) {
    return getVGSubscriptionUrl(asset, overrides);
  } else if (provider === Provider.AB) {
    return getABSubscriptionUrl(asset, overrides);
  }

  return '';
}
